module.exports = "body\n{height: 50%;}\n\n.legacy-footer {\n  margin-top: 50px;\n  padding: 20px;\n  text-align: center;\n  font-family: sans-serif; /* Keeps it clean */\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.legacy-footer hr {\n  width: 1000%;\n  margin-bottom: 20px;\n  border: 0;\n  text-align:center;\n  border-top: 1px solid #eee;\n};"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main